import Decimal from 'decimal.js'

/** Truncate to specified decimal places (no rounding) */
export function toFixed(number: number | string, p: number): string {
  const num = isNaN(Number(number)) || !number ? 0 : number
  const precision = isNaN(p) || !p ? 0 : p
  const full = toFull(num)
  const parts = String(full).split('.')
  let decimal = parts.length > 1 ? parts[1] : ''
  if (decimal.length > precision) {
    decimal = decimal.substring(0, precision)
  } else {
    decimal += '0'.repeat(precision - decimal.length)
  }
  return parts[0] + (decimal === '' ? '' : '.' + decimal)
}

/** Convert scientific notation to plain number */
export function toFull(num: number | string): number | string {
  if (isNaN(Number(num))) return num
  const str = String(num)
  if (!/e/i.test(str)) return num
  return Number(num).toFixed(18).replace(/\.?0+$/, '')
}

/** Precise addition */
export function decadd(arg1: number | string, arg2: number | string): string {
  return new Decimal(String(arg1)).add(new Decimal(String(arg2))).toFixed()
}

/** Precise subtraction */
export function decsub(arg1: number | string, arg2: number | string): string {
  return new Decimal(String(arg1)).sub(new Decimal(String(arg2))).toFixed()
}

/** Precise multiplication */
export function decmul(arg1: number | string, arg2: number | string): string {
  if (!arg1 || !arg2) return '0'
  return new Decimal(String(arg1)).mul(new Decimal(String(arg2))).toFixed()
}

/** Precise division */
export function decdiv(arg1: number | string, arg2: number | string): string {
  if (!arg1 || !arg2) return '0'
  return new Decimal(String(arg1)).div(new Decimal(String(arg2))).toFixed()
}

/** Convert scientific notation to decimal string */
export function toNonExponential(num: number | string | null): string {
  if (num === null || isNaN(Number(num))) return '0'
  return new Decimal(String(num)).toFixed()
}

/** Format number with thousand separators */
export function formatNumber(num: number | string, decimals?: number): string {
  if (isNaN(Number(num))) return '0'
  const parts = String(num).split('.')
  const fractionLength = parts.length > 1 ? parts[1].length : 0
  if (decimals) {
    return Number(toFixed(num, decimals)).toLocaleString('en', {
      minimumFractionDigits: fractionLength,
    })
  }
  return Number(num).toLocaleString('en', { minimumFractionDigits: fractionLength })
}
